/**
 * Shortlist filter (Sofia, Oct 19 2026): tick must-haves, see only the people whose profile SHOWS
 * every ticked one — the full-profile check when it exists, else the list evidence.
 */
import type { Dispatch, SetStateAction } from 'react';
import { cn } from '../../../../shared';
import type { OutreachCandidate } from '../../types/taOutreach';

/** The must-haves this candidate's profile SHOWS, by label (full-profile check first, else the list). */
export function shownLabels(c: OutreachCandidate): Set<string> {
  if (c.gap) return new Set(c.gap.criteria.filter((x) => x.mustHave && x.verdict === 'evidenced').map((x) => x.label));
  return new Set((c.sourcing?.evidence || []).filter((e) => e.verdict === 'yes').map((e) => e.label));
}

/** Every must-have label on the shortlist, in the order the checks list them. */
export function mustHaveLabels(list: OutreachCandidate[]): string[] {
  const out: string[] = [];
  for (const c of list) {
    const labels = c.gap ? c.gap.criteria.filter((x) => x.mustHave).map((x) => x.label) : (c.sourcing?.evidence || []).map((e) => e.label);
    for (const l of labels) if (l && !out.includes(l)) out.push(l);
  }
  return out;
}

export function MustHaveFilter({
  labels,
  candidates,
  value,
  onChange,
}: {
  labels: string[];
  candidates: OutreachCandidate[];
  value: string[];
  onChange: Dispatch<SetStateAction<string[]>>;
}) {
  if (!labels.length) return null;
  return (
    <div className="flex flex-wrap items-center gap-1.5" role="group" aria-label="Filter by must-have">
      <span className="text-xs text-[#707070]">Profile shows:</span>
      {labels.map((l) => {
        const on = value.includes(l);
        const n = candidates.filter((c) => shownLabels(c).has(l)).length;
        return (
          <button
            key={l}
            type="button"
            aria-pressed={on}
            onClick={() => onChange((cur) => (on ? cur.filter((x) => x !== l) : [...cur, l]))}
            className={cn(
              'rounded-full border border-solid px-2.5 py-1 text-xs',
              on ? 'border-[#1D9247] bg-[#DEF5E6] text-[#1D9247]' : 'border-[#E9EAEC] bg-white text-[#707070] hover:border-[#979797]'
            )}
          >
            {on ? '✓ ' : ''}
            {l} <span className="text-[#979797]">{n}</span>
          </button>
        );
      })}
      {value.length > 0 && (
        <button type="button" className="text-xs text-[#0072EA] underline" onClick={() => onChange([])}>
          Clear
        </button>
      )}
    </div>
  );
}
